import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { Badge, RadioGroup, RadioGroupOption, useLocalizeMessage } from 'libs.nucleus';
import { AuthContext } from 'libs.react_internal';
import { DataTransferTemplateContext } from '../../../contexts/data_transfer_template/data_transfer_template.context';
export const CreateTransferTemplateStep1 = () => {
    const translate = useLocalizeMessage();
    const { isInternalUser } = useContext(AuthContext);
    const { templateCreationOption, setTemplateCreationOption } = useContext(DataTransferTemplateContext);
    const handleOptionChange = (option) => {
        setTemplateCreationOption(option);
    };
    const creationOptions = useMemo(() => [
        {
            label: translate('Create a new data transfer template'),
            description: translate('Build a template to use for your data transfers.'),
            value: 'data_builder',
            dataTestId: 'data-builder-transfer-template',
            isInternal: false,
        },
        ...(isInternalUser
            ? [
                {
                    label: translate('Create a new data transfer template (Advanced)'),
                    description: translate('Use the SQL editor to build your template.'),
                    value: 'sql_editor',
                    dataTestId: 'sql-editor-transfer-template',
                    isInternal: true,
                },
            ]
            : []),
        {
            label: translate('Clone a data transfer template'),
            description: translate('Copy an existing template and modify basic information.'),
            value: 'clone',
            dataTestId: 'clone-transfer-template',
            isInternal: false,
        },
    ], [translate, isInternalUser]);
    return (_jsx("div", { className: 'flex flex-col items-center justify-center size-full', children: _jsxs("div", { className: 'min-w-[50%] space-y-4', children: [_jsx("div", { className: 'text-lg font-semibold', children: translate('Select how you would like to get started') }), _jsx(RadioGroup, { value: templateCreationOption, onChange: handleOptionChange, children: creationOptions.map((option) => (_jsx("div", { className: `w-full border rounded-lg p-5 cursor-pointer transition-colors ${templateCreationOption === option.value ? 'border-indigo-500' : 'border-gray-200 hover:border-gray-400'}`, children: _jsxs("div", { className: 'flex items-center justify-between gap-4', children: [_jsx(RadioGroupOption, { option: option }), option.isInternal && _jsx(Badge, { label: translate('Internal') })] }) }, option.value))) })] }) }));
};
